import axiosInstance from "./mainApi";
import store from "../store/store";

import {
  addColor,
  addMoreColors,
  replaceStoreWithMoreColors,
  deleteColor,
  updateColor
} from "../store/actions/colorStoreFunctions";

import {
  saveColors,
  getAllColorsFromDB,
  deleteColorFromDB,
  isFullColorSyncDue
} from "../localDB/colorDb";

import { refreshColors } from "./colorSync";

const COLOR_LAST_QUERY_KEY = "colors:lastQueryDate";
const COLOR_LAST_REFRESH_KEY = "colors:lastRefreshDate";

const DEFAULT_QUERY_DATE = "2000-01-01T00:01:00Z";


// ======================
// LOCAL STORAGE
// ======================

export const getColorLastQueryDate = () =>
  localStorage.getItem(COLOR_LAST_QUERY_KEY) || DEFAULT_QUERY_DATE;

export const getColorLastRefreshDate = () =>
  localStorage.getItem(COLOR_LAST_REFRESH_KEY) || DEFAULT_QUERY_DATE;

export const setColorLastQueryDate = (date = new Date()) => {
  const iso = typeof date === "string" ? date : date.toISOString();

  localStorage.setItem(COLOR_LAST_QUERY_KEY, iso);
};

export const setColorLastRefreshDate = (date = new Date()) => {
  const iso = typeof date === "string" ? date : date.toISOString();

  localStorage.setItem(COLOR_LAST_REFRESH_KEY, iso);
};

export const shouldFullRefreshColors = () =>
  isFullColorSyncDue(getColorLastRefreshDate());

// ======================
// GET
// ======================

export const syncColorsToStore = (options = {}) => {
  return refreshColors(
    (batch) => store.dispatch(addMoreColors(batch)),
    ({ colors, lastQueryDate, lastFullRefresh }) => {
      store.dispatch(replaceStoreWithMoreColors(colors));
      setColorLastQueryDate(lastQueryDate);
      if (lastFullRefresh) setColorLastRefreshDate(lastFullRefresh);
    },
    options
  ).catch((err) => {
    console.error("Color refresh paused; it will resume from the saved page:", err);
    return false;
  });
};

const getAllColorsApi = async () => {
  console.log("🎨 getAllColorsApi() called");

  let localColors = [];

  try {
    localColors = await getAllColorsFromDB();

    console.log("📦 Local DB colors:", localColors.length);

    store.dispatch(addMoreColors(localColors));
  } catch (err) {
    console.error("❌ IndexedDB error:", err);
  }

  syncColorsToStore();

  return localColors;
};

// ======================
// DELETE
// ======================

const deleteColorApi = (colorId) => {
  return async (dispatch) => {
    await axiosInstance.delete(`/colors/${colorId}`);

    await deleteColorFromDB(colorId);

    dispatch(deleteColor(colorId));
  };
};

// ======================
// UPDATE
// ======================

const updateColorApi = (colorId, updatedColorData) => {
  return async (dispatch) => {
    const response = await axiosInstance.put(
      `/colors/${colorId}`,
      updatedColorData
    );

    await saveColors([response.data]);

    dispatch(updateColor(response.data));

    return response.data;
  };
};

// ======================
// CREATE
// ======================

const createColorApi = (colorData) => {
  return async (dispatch) => {
    const response = await axiosInstance.post("/colors", colorData);

    await saveColors([response.data]);

    dispatch(addColor(response.data));

    return response.data;
  };
};

export default {
  getAllColorsApi,
  deleteColorApi,
  updateColorApi,
  createColorApi
};
